type EnvRecord = Record<string, string | undefined>;

export const getEnv = (key: string): string | undefined => {
  try {
    const metaEnv = typeof import.meta !== 'undefined' ? ((import.meta as any).env as EnvRecord | undefined) : undefined;
    if (metaEnv && key in metaEnv) return metaEnv[key];
  } catch {
    // Ignore if import.meta is not available.
  }

  if (typeof process !== 'undefined' && process.env) {
    const value = (process.env as EnvRecord)[key];
    if (value) return value;
  }

  return undefined;
};
